import { render, staticRenderFns } from "./ProjectProposalDetails.vue?vue&type=template&id=c0dee23a&"
import script from "./ProjectProposalDetails.vue?vue&type=script&lang=ts&"
export * from "./ProjectProposalDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectProposalDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports